<template>
  <div class="teaser-block col-12">
    <p v-if="heading" class="text-lg text-center text-uppercase">
      {{ heading }}
    </p>
    <div class="teaser-content">
      <div class="teaser-text">
        <p v-if="text" class="text-lg text-family-secondary">
          {{ text }}
        </p>
        <router-link v-if="entryLink?.url" :to="entryLink?.url" class="btn-icon-right mt-2"></router-link>

      </div>

      <div v-if="image?.url" class="teaser-image">
        <img
          :src="image.url"
          :alt="image.title || heading"
          :width="image.width"
          :height="image.height"
          loading="lazy"
        />
      </div>
    </div>

  </div>
</template>

<script setup>
defineProps({
  heading: { type: String, default: null },
  text: { type: String, default: null },
  entryLink: { type: Object, default: null },
  image: { type: Object, default: null }
})
</script>